import { BlurredContent } from '~/@mid_ui/blurred-content/BlurredContent'
import type { ProjectsTableMeta } from '../../running-projects/useRunningProjectsTable'
import { isProjectBlurred } from './isProjectBlurred'

type BlurState = {
  sendCellInfo: any
  children: React.ReactNode
}

function ProjectBlurredContent({
  sendCellInfo,
  children,
}: BlurState): React.ReactNode {
  const isBlurred = (function () {
    const meta = sendCellInfo.table.options.meta as ProjectsTableMeta
    const blurTags = sendCellInfo.row.original.blurTags
    const userTags = meta.userMeta?.tags
    return isProjectBlurred(blurTags, userTags)
  })()

  if (isBlurred) return <BlurredContent>{children}</BlurredContent>

  return children
}

export { ProjectBlurredContent }
